import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {v4 as uuid} from 'uuid'
import {useAuth} from "@/context/use-auth.tsx";
import {UserDTO} from "@/models/user.ts";
import {createNewUser} from "@/services/user-services.ts";
import UserForm from "@/components/user-form.tsx";

export default function NewUserPage() {
    const navigate = useNavigate()
    const [userData, setUserData] = useState<UserDTO>()
    const {token} = useAuth()

    useEffect(() => {
        const newUser = {} as UserDTO
        setUserData(newUser)
    }, []);

    function handleSubmission(form: any) {
        const userData: UserDTO = {
            active: form.active,
            id: uuid(),
            name: form.name,
            password: form.password,
            role: form.role,
            username: form.username,
            email: form.email || undefined,
        }

        // Return the promise so UserForm can surface backend validation issues (e.g. password
        // policy findings) as field errors. A rejection here propagates into the form's submit
        // handler instead of being swallowed.
        return createNewUser(userData, token!).then(() => {
            navigate("/admin/users")
        })
    }

    return (
        <UserForm 
            mode="create"
            initialData={userData}
            onSubmit={handleSubmission}
        />
    )
}